import defaultLogo from '../assets/BDSA_clear.png';

export const DEFAULT_SITE_TITLE = 'Brain Digital Slide Archive';
const DEFAULT_LOGO_FILE = 'BDSA_clear.png';

const logoModules = import.meta.webpackContext('../assets', {
    recursive: false,
    regExp: /\.(png|jpe?g|gif|svg|webp)$/i,
});

function logoModuleSrc(mod) {
    if (!mod) return null;
    if (typeof mod === 'string') return mod;
    if (typeof mod.default === 'string') return mod.default;
    return mod.default || null;
}

export function isPdsaMode() {
    return /^(true|1|yes)$/i.test(String(import.meta.env.REACT_APP_PDSA_MODE || ''));
}

export function getSiteTitle() {
    const title = String(import.meta.env.REACT_APP_SITE_TITLE || '').trim();
    return title || DEFAULT_SITE_TITLE;
}

/**
 * Resolve a filename under src/assets (LOGO_FILE). Path segments are stripped;
 * unknown files fall back to BDSA_clear.png.
 */
export function getAppLogoSrc() {
    const raw = String(import.meta.env.REACT_APP_LOGO_FILE || '').trim() || DEFAULT_LOGO_FILE;
    const name = raw.replace(/^.*[/\\]/, '');
    const key = `./${name}`;
    if (logoModules.keys().includes(key)) {
        return logoModuleSrc(logoModules(key)) || defaultLogo;
    }
    return defaultLogo;
}
